.devNext {
  align-self: center;
  cursor: pointer;
  text-decoration: underline;
  font-size: 8px;
}
